import React from "react";
import { MaterialDesignIcons } from "../styled";

export const DragIndicatorMIcon = () => {
  return <MaterialDesignIcons className="ico">drag_indicator</MaterialDesignIcons>;
};
